// Function to update the cart count display
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElement = document.querySelector('.cart-count');
      if (cartCountElement) {
        cartCountElement.textContent = cart.item_count;
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

// Function to show the custom cart notification popup
function showCartNotification(message) {
  const popup = document.getElementById('cart-notification-popup');
  const messageElement = document.getElementById('cart-notification-message');

  if (popup && messageElement) {
    messageElement.textContent = message;
    popup.classList.add('show');

    // Hide the popup after a few seconds
    setTimeout(() => {
      popup.classList.remove('show');
    }, 3000); // Adjust time as needed (e.g., 3000ms = 3 seconds)
  }
}

// Listen for custom event to update cart count and show notification
document.addEventListener('cart:item_added', (event) => {
  updateCartCount();
  const quantity = event.detail.addedQuantity;
  // Get translation from data attribute or use fallback
  const notificationElement = document.getElementById('cart-notification-popup');
  const template = notificationElement?.dataset.addedMessage || 'Added {{ quantity }} item(s) to cart';
  const message = template.replace('{{ quantity }}', quantity);
  showCartNotification(message);
});

// Initial update on page load
document.addEventListener('DOMContentLoaded', updateCartCount);